import React from 'react'
import PropTypes from 'prop-types'
import { Article } from '../components/Article'
import board5 from '../images/board5.jpg'

export function A05({ index }) {
  return (
    <Article
      index={index}
      heading="In need of financing to continue development, the entrepreneur issues governance tokens to fundraise."
      image={board5}
      imageDescription="Alice plans her fundraising strategy at a whiteboard."
    >
      <div className="article-row">
        <span>
          <p>
            Access to funding is one of the most basic entrepreneurial needs
            that the Internet Computer can address directly. Because CanCan runs
            on the Internet Computer, Alice has the ability to issue unforgeable
            governance tokens that ultimately control the app. To raise money
            for CanCan, she issues 1 billion governance tokens for the app with
            just a few lines of code.
            <br />
            <br />
            In doing so, Alice has converted CanCan from a standard software
            application to an open internet service. The app is now under the
            control of the owners of the governance tokens, which can also be
            used to distribute rewards and bounties to open source developers.
            Even Alice, who originally authored the app, cannot control or
            update the CanCan application unilaterally anymore. All updates
            going forward will require voting with tokens. She initially owns
            all of the tokens, of course, but a community of governance token
            holders will grow as she gifts, sells, donates these tokens to
            others. It is this community that will ultimately control CanCan.
          </p>
        </span>
        <aside>
          <h4>Governance Tokens</h4>
          <p>
            The Internet Computer allows developers to issue governance tokens
            for their applications. These tokens cannot be forged. They are used
            to vote on the control of the application.
          </p>
        </aside>
      </div>
    </Article>
  )
}

A05.propTypes = {
  index: PropTypes.number.isRequired,
}
